/* eslint-disable max-classes-per-file */
/* eslint-disable no-use-before-define */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ImageFileProcessor } from '@printu/file-reader';
import FileReaderWorker from '@printu/file-reader/dist/worker-min.js';
const getDefaultProcessorConfig = () => {
    const config = {
        fixOrientation: false,
        createThumbnail: false,
        createBitmap: false,
        thumbnailQuality: 0.75,
        thumbnailSize: { width: 0, height: 0 },
        supportedImageTypes: ['image/jpeg', 'image/png'],
        bitmapAutoOrientResizeSupported: false,
        uiThreadDisableCreateThumbnail: true,
        uiThreadDisableImageBitmap: false,
        uiThreadImageLoadStrategy: 'image',
        deadLoopGuardSize: 2000,
        jpegApplyMarkerFix: true,
        maxMetaDataSize: 10000,
    };
    return config;
};
const Defaults = {
    suppressWarnings: false,
    defaultMime: 'image/unknown',
    supportedImageTypes: ['image/jpeg', 'image/png'],
    fileMaxSize: 23068672,
    delegate: {
        imageWorkerDidComplete: () => {
            /** noop */
        },
        imageWorkerDidFail: (_i, _s, error) => {
            console.error(error);
        },
        imageWorkerWillStart: () => {
            /** noop */
        },
    },
};
class ProcessorWorker extends Worker {
    constructor() {
        super(ProcessorWorker.getUrl());
    }
    static getUrl() {
        if (!this.url) {
            const blob = new Blob([FileReaderWorker], {
                type: 'application/javascript',
            });
            this.url = URL.createObjectURL(blob);
        }
        return this.url;
    }
}
Object.defineProperty(ProcessorWorker, "url", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: ''
});
export class FileProcessor {
    constructor() {
        Object.defineProperty(this, "processor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new ImageFileProcessor(ProcessorWorker)
        });
    }
    static newInstance() {
        return new FileProcessor();
    }
    process(fileInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.processor.process(fileInfo, Object.assign(Object.assign({}, Defaults), { processor: getDefaultProcessorConfig() }));
        });
    }
}
